import "./styles/global.scss";
import Routes from "./routes/index";
import { AuthProvider } from "./hooks/useAuth";
import { TourProvider } from "@reactour/tour";

const steps = [
  {
    selector: "",
    content: "",
  },
];

function App() {
  return (
    <AuthProvider>
      <TourProvider steps={steps}>
        <Routes />
      </TourProvider>
    </AuthProvider>
  );
}

export default App;
